var styles = {"breakpoint-sm":"(min-width: 768px)","breakpointSm":"(min-width: 768px)","popover":"styles_popover__1OCxr","content":"styles_content__2HFVn relative","light":"styles_light__aMeSe","arrow":"styles_arrow__1kSNO","dark":"styles_dark__2jEte","small":"styles_small__3Vr1a","large":"styles_large__3UUon"};

export default styles;
//# sourceMappingURL=styles.css.js.map
